import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Typography from '@sharedComponents/Typography';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import * as style from './style.module.css';

const colorMap = {
    success: 'success-primary',
    warning: 'warning-primary',
    error: 'error-primary',
    info: 'neutral-primary',
    tip: 'tip-primary',
};

const iconClassMap = {
    success: style.successIcon,
    warning: style.warningIcon,
    error: style.errorIcon,
    info: style.infoIcon,
    tip: style.tipIcon,
};

function InformationMessage({ status = 'info', text = '', icon = null, isTextColored = true, children }) {
    const { t } = useTranslation();
    return (
        <div className={cx(style.container, style[status])}>
            {icon && (
                <span className={cx(style.iconWrapper, iconClassMap[status])}>
                    <FontAwesomeIcon icon={icon} />
                </span>
            )}
            <Typography color={isTextColored ? colorMap[status] : undefined}>
                {status === 'tip' && <strong>{t('Tip: ')}</strong>}
                {children ?? text}
            </Typography>
        </div>
    );
}

InformationMessage.propTypes = {
    status: PropTypes.oneOf(['success', 'error', 'warning', 'info', 'tip']),
    text: PropTypes.string,
    icon: PropTypes.oneOfType([PropTypes.object]),
    isTextColored: PropTypes.bool,
    children: PropTypes.node,
};

export default InformationMessage;
